/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespHeroBannerText_heroBannerSettings = {
    readonly textAlignment: string | null;
    readonly contentColor: string | null;
    readonly eyeBrowText: string | null;
    readonly headerText: string | null;
    readonly dekText: string | null;
    readonly ctaStyle: string | null;
    readonly " $refType": "HpRespHeroBannerText_heroBannerSettings";
};
export type HpRespHeroBannerText_heroBannerSettings$data = HpRespHeroBannerText_heroBannerSettings;
export type HpRespHeroBannerText_heroBannerSettings$key = {
    readonly " $data"?: HpRespHeroBannerText_heroBannerSettings$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_heroBannerSettings">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespHeroBannerText_heroBannerSettings",
  "type": "HeroBannerSettingsType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "textAlignment",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentColor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "eyeBrowText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "dekText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ctaStyle",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '709f5c724a5922c3929ac25a0852f625';
export default node;
